import React from 'react';
import { Box, Switch, Typography } from '@mui/material';
import { makeStyles } from '@mui/styles';

import { appColors, backgroundColors } from 'src/consts/app-config';

type SwitchSettingItemProps = {
    text: string;
    isChecked: boolean;
    onChange: () => void;
    isWaitingChanges?: boolean;
};

const useStyles = makeStyles({
    box: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
    },
    text: {
        fontSize: 16,
        fontWeight: 400,
        color: 'rgba(245, 245, 245, 0.9)',
    },
    switch: {
        width: 40,
        height: 24,
        padding: 0,
        '& .MuiSwitch-switchBase': {
            padding: 0,
            margin: 0,
            left: 2,
            top: '50%',
            transform: 'translateY(-50%)',
            transitionDuration: '300ms',
            '&.Mui-checked': {
                transform: 'translateY(-50%) translateX(16px)',
                color: appColors.white,
                '& + .MuiSwitch-track': {
                    background: '#00BA6C',
                    opacity: 1,
                    border: 0,
                },
                '&.Mui-disabled + .MuiSwitch-track': {
                    opacity: 0.5,
                },
            },
            '&.Mui-focusVisible .MuiSwitch-thumb': {
                color: '#33cf4d',
                border: '6px solid #fff',
            },
            '&.Mui-disabled .MuiSwitch-thumb': {
                color: 'gray',
            },
            '&.Mui-disabled + .MuiSwitch-track': {
                opacity: 0.7,
            },
        },
        '& .MuiSwitch-thumb': {
            boxSizing: 'border-box',
            width: 20,
            height: 20,
        },
        '& .MuiSwitch-track': {
            borderRadius: 26 / 2,
            background: 'transparent',
            border: '1px solid rgba(255, 255, 255, 0.3)',
            opacity: 1,
            transition: '1s ease',
        },
    },
});

const SwitchSettingItem = ({
    text,
    isChecked,
    onChange,
    isWaitingChanges,
}: SwitchSettingItemProps) => {
    const styles = useStyles();
    return (
        <Box className={styles.box}>
            <Typography className={styles.text}>{text}</Typography>
            <Switch
                disabled={isWaitingChanges}
                checked={isChecked}
                onChange={onChange}
                className={styles.switch}
            />
        </Box>
    );
};

export default SwitchSettingItem;
